import { GoldCalculatorProps } from '../../common/types';
import { CARAT_OPTIONS, useGoldCalculator } from './utils';

export const GoldCalculator = ({ data }: GoldCalculatorProps): JSX.Element => {
  const {
    selectedCarat,
    setSelectedCarat,
    isWeightToAmount,
    inputValue,
    setInputValue,
    ratePerGram,
    calculateResult,
    handleSwap,
  } = useGoldCalculator({ data });

  return (
    <div className="border border-[#E8D5A3] rounded-lg p-6 sm:p-4 bg-[#FFF9EE]">
      <div className="flex gap-2 mb-6 items-center sm:justify-center">
        <div className="font-bold sm:text-s-12 whitespace-nowrap">Carat :</div>{' '}
        {CARAT_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => setSelectedCarat(option.value)}
            className={`w-10 h-10 sm:w-8 sm:h-8 rounded-full text-s-14 sm:text-s-10 font-semibold transition-colors ${
              selectedCarat === option.value
                ? 'bg-[#B8860B] text-white'
                : 'bg-[#F5E6C8] text-[#8B6914] hover:bg-[#E8D5A3]'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-4 sm:flex-col sm:gap-3">
        <div className="flex-1 sm:w-full">
          <label className="text-s-12 text-font-500 font-semibold mb-1 block">
            {isWeightToAmount ? 'Weight (grams)' : 'Amount (₹)'}
          </label>
          <input
            type="number"
            value={inputValue}
            min="0"
            onKeyDown={(e) => e.key === '-' && e.preventDefault()}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={
              isWeightToAmount ? 'Enter weight in grams' : 'Enter amount in ₹'
            }
            className="w-full border border-[#EBEBEC] rounded-md px-4 py-3 text-s-14 text-font-500 outline-none focus:border-blue-350"
          />
        </div>

        <button
          onClick={handleSwap}
          className="mt-5 sm:mt-0 p-2 rounded-full bg-white border border-[#EBEBEC] hover:bg-[#F5F5F5] transition-colors"
          title="Swap"
        >
          {/* Horizontal arrows for desktop */}
          <svg
            className="block sm:hidden"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 7H4m0 0l4-4M4 7l4 4M8 17h12m0 0l-4-4m4 4l-4 4" />
          </svg>
          {/* Vertical arrows for mobile */}
          <svg
            className="hidden sm:block"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
          </svg>
        </button>

        <div className="flex-1 sm:w-full">
          <label className="text-s-12 text-font-500 font-semibold mb-1 block">
            {isWeightToAmount ? 'Amount (₹)' : 'Weight (grams)'}
          </label>
          <div className="w-full border border-[#EBEBEC] rounded-md px-4 py-3 text-s-14 text-font-500 bg-[#F9F9F9] min-h-[46px]">
            {calculateResult()}
          </div>
        </div>
      </div>

      <p className="text-s-12 text-font-500 font-semibold mt-3">
        Rate: ₹{ratePerGram.toLocaleString('en-IN')}/g (
        {selectedCarat.toUpperCase()})
      </p>
    </div>
  );
};
